import { useEffect, useState } from "react";
import usePoll from "@/hooks/usePoll";
import { api } from "@/lib/api";
import { ErrorBox, ExportBar, Kpi, Loading, Sel } from "@/components/common";

const Table = ({ title, rows, testid }) => (
  <div className="k-card p-5"><div className="font-bold mb-2">{title}</div>
    <table className="k-table" data-testid={testid}><thead><tr><th>{title.split(" ").pop()}</th><th>المسجل</th><th>تحول إلى بيع</th><th>معلق</th></tr></thead>
      <tbody>{rows.map((r) => <tr key={r.key}><td className="font-bold">{r.key}</td><td className="num">{r.total}</td><td className="num">{r.sold}</td><td className="num">{r.pending}</td></tr>)}</tbody></table>
  </div>
);

export default function SelectionReport({ range }) {
  const [f, setF] = useState({ worker_id: "", section_id: "" });
  const [sections, setSections] = useState([]);
  useEffect(() => { api.get("/sections").then((r) => setSections(r.data)).catch(() => {}); }, []);
  const params = Object.fromEntries(Object.entries({ ...range, ...f }).filter(([, v]) => v));
  const { data: d, error } = usePoll("/reports/selections", params, 30000);
  return (
    <section className="space-y-4" data-testid="selection-report">
      <div className="flex flex-wrap items-center gap-3">
        <h2 className="font-display font-bold text-lg flex-1">اختيارات الحضيرة والإدخال اليدوي</h2>
        <Sel value={f.worker_id} onChange={(v) => setF({ ...f, worker_id: v })} testid="sel-report-worker" className="w-48"><option value="">كل العمال</option>{(d?.workers || []).map((w) => <option key={w.id} value={w.id}>{w.full_name}</option>)}</Sel>
        <Sel value={f.section_id} onChange={(v) => setF({ ...f, section_id: v })} testid="sel-report-section" className="w-48"><option value="">كل الأقسام</option>{sections.map((s) => <option key={s.id} value={s.id}>{s.code} – {s.name}</option>)}</Sel>
        {d && <ExportBar name="selections-report" rows={d.by_worker} cols={[{ key: "key", label: "العامل" }, { key: "total", label: "المسجل" }, { key: "sold", label: "تحول إلى بيع" }, { key: "pending", label: "معلق" }]} />}
      </div>
      <ErrorBox text={error} />
      {!d ? <Loading /> : (
        <>
          <div className="grid grid-cols-2 lg:grid-cols-5 gap-4">
            <Kpi testid="kpi-selections-total" label="اختيارات مسجلة من الحضيرة" value={d.selections_total} sub={`معلق ${d.by_status.pending} • تعذر ${d.by_status.failed} • ملغى ${d.by_status.cancelled}`} />
            <Kpi testid="kpi-selections-sold" label="تحولت إلى مبيعات فعلية" value={d.by_status.sold} sub={`نسبة التحويل ${d.conversion_pct}%`} tone="blue" />
            <Kpi testid="kpi-sales-barn" label="مبيعات مصدرها الحضيرة" value={d.sales_from_barn} tone="green" />
            <Kpi testid="kpi-sales-manual" label="مبيعات مدخلة يدويًا من المكتب" value={d.sales_manual} tone="ochre" />
            <Kpi label="إجمالي المبيعات" value={d.sales_from_barn + d.sales_manual} tone="slate" />
          </div>
          <div className="grid lg:grid-cols-2 gap-4">
            <Table title="حسب العامل" rows={d.by_worker} testid="sel-report-by-worker" />
            <Table title="حسب القسم" rows={d.by_section} testid="sel-report-by-section" />
          </div>
        </>
      )}
    </section>
  );
}
